// extracted by mini-css-extract-plugin
export var trailStatSection = "styles-module__trailStatSection___k3Vnr";
export var trailStatIcons = "styles-module__trailStatIcons___O_ahK";
export var detailData = "styles-module__detailData___fxmwv";
export var statsLabel = "styles-module__statsLabel___XF1A6";